import React from "react";
import { Scissors, Gamepad2, BookOpen, Check } from "lucide-react";
import WhatsAppButton from "./WhatsAppButton";
import {
  capcutProducts,
  gameProducts,
  ebookProducts,
  buildWA,
} from "../data/catalog";

const SectionHeader = ({ kicker, title, subtitle }) => (
  <div className="max-w-3xl">
    <div className="text-xs tracking-[0.22em] uppercase text-[#9B5BFF] font-medium">
      — {kicker}
    </div>
    <h2 className="font-display font-extrabold text-4xl sm:text-5xl mt-4 leading-[1.05]">
      {title}
    </h2>
    {subtitle && (
      <p className="mt-4 text-white/65 text-base sm:text-lg leading-relaxed">
        {subtitle}
      </p>
    )}
  </div>
);

/* ---------------- CAPCUT ---------------- */
const CapcutSection = () => (
  <div data-testid="capcut-section" className="relative">
    {/* Banner */}
    <div className="relative overflow-hidden rounded-[28px] glass-purple p-8 sm:p-12">
      <div className="absolute -top-24 -right-16 w-[360px] h-[360px] rounded-full bg-[#7B2DFF]/35 blur-3xl" />
      <div className="absolute -bottom-24 -left-16 w-[300px] h-[300px] rounded-full bg-[#3a0ca3]/40 blur-3xl" />
      <div className="relative grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-[11px] tracking-[0.18em] uppercase text-[#cdb6ff]">
            <Scissors size={14} /> Premium Editor
          </div>
          <h3 className="font-display font-black text-4xl sm:text-5xl mt-5 leading-[1.02]">
            <span className="text-white">Capcut</span>{" "}
            <span className="gradient-purple">Premium</span>
          </h3>
          <p className="mt-4 text-white/70 text-base sm:text-lg leading-relaxed max-w-xl">
            Editing tanpa watermark, fitur lengkap, export HD, template premium, harga hemat.
          </p>
          <ul className="mt-5 grid sm:grid-cols-2 gap-2 text-sm text-white/75">
            {[
              "Tanpa Watermark",
              "Export 4K / HD",
              "Template Premium",
              "Semua Fitur Pro Aktif",
            ].map((it) => (
              <li key={it} className="flex items-center gap-2">
                <Check size={16} className="text-[#9B5BFF]" /> {it}
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-5">
          <div className="grid gap-4">
            {capcutProducts.map((p) => (
              <div
                key={p.id}
                data-testid={`capcut-card-${p.id}`}
                className="product-card p-5 sm:p-6 flex items-center gap-4"
              >
                <div className="w-14 h-14 rounded-2xl flex items-center justify-center bg-gradient-to-br from-[#7B2DFF] to-[#3a0ca3] glow-purple shrink-0 overflow-hidden">
  {p.cover ? (
    <img
      src={p.cover}
      alt={p.name}
      className="w-10 h-10 object-contain"
    />
  ) : (
    <Scissors size={22} />
  )}
</div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2">
                    <h4 className="font-display font-bold text-base sm:text-lg leading-tight">
                      {p.name}
                    </h4>
                    <span className="text-[10px] uppercase tracking-[0.14em] px-2 py-0.5 rounded-full bg-[#7B2DFF]/20 text-[#cdb6ff] border border-[#7B2DFF]/30 whitespace-nowrap">
                      {p.badge}
                    </span>
                  </div>
                  <p className="text-white/55 text-xs sm:text-sm mt-1">
                    {p.desc}
                  </p>
                  <div className="font-display font-extrabold text-xl mt-2 gradient-purple">
                    {p.price}
                  </div>
                </div>
                <WhatsAppButton
                  testId={`capcut-buy-${p.id}`}
                  href={buildWA(p.name, p.price)}
                  className="!py-2.5 !px-4 text-xs"
                >
                  Beli
                </WhatsAppButton>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);

/* ---------------- GAME REPACK ---------------- */
const GameCard = ({ p }) => (
  <div
    data-testid={`game-card-${p.id}`}
    className="product-card p-3 sm:p-4 flex flex-col"
  >
    <div className="game-frame aspect-[16/9] bg-[#0d0d12]">
      {p.cover ? (
        <img
          src={p.cover}
          alt={p.name}
          className="w-full h-full object-cover transition duration-700 hover:scale-110"
          loading="lazy"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-[#1a0a36] to-[#0B0B0B]">
          <Gamepad2 size={68} className="text-[#9B5BFF]" />
        </div>
      )}
      <div className="absolute top-3 left-3 z-10 px-2.5 py-1 rounded-full bg-[#7B2DFF]/30 border border-[#7B2DFF]/40 text-[10px] tracking-[0.14em] uppercase text-[#e7d8ff]">
        {p.tag}
      </div>
    </div>
    <div className="mt-4 flex-1">
      <h4 className="font-display font-bold text-base sm:text-lg leading-tight">
        {p.name}
      </h4>
      <div className="mt-1 flex items-center justify-between">
        <span className="font-display font-extrabold text-lg gradient-purple">
          {p.price}
        </span>
        <span className="text-[11px] text-white/45">Repack · Aman</span>
      </div>
    </div>
    <WhatsAppButton
      testId={`game-buy-${p.id}`}
      href={buildWA(p.name, p.price)}
      className="!py-2.5 mt-4 text-sm"
      fullWidth
    >
      {p.request ? "Request via WhatsApp" : "Beli via WhatsApp"}
    </WhatsAppButton>
  </div>
);

const GameSection = () => (
  <div data-testid="game-section">
    <div className="rounded-[28px] glass-purple overflow-hidden">
      <div className="relative p-8 sm:p-10 border-b border-white/5">
        <div className="absolute -top-24 right-0 w-[420px] h-[420px] rounded-full bg-[#7B2DFF]/25 blur-3xl" />
        <div className="relative">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-[11px] tracking-[0.18em] uppercase text-[#cdb6ff]">
            <Gamepad2 size={14} /> Game Repack
          </div>
          <h3 className="font-display font-black text-4xl sm:text-5xl mt-5 leading-[1.02]">
            Game Repack <span className="gradient-purple">Aman & Terpercaya, Anti Virus</span>
          </h3>
          <p className="mt-5 text-white/70 text-base leading-[1.85] max-w-3xl">
            Semua game repack yang tersedia telah melalui proses pengecekan dan
            pengujian instalasi terlebih dahulu. File installer dipastikan
            berjalan normal, ukuran lebih ringan, performa stabil, dan tidak
            mengandung virus maupun malware. Setiap game sudah dicoba proses
            install hingga selesai dan dapat dimainkan dengan lancar. Cocok
            untuk pengguna yang ingin game murah, aman, dan praktis tanpa
            khawatir file berbahaya.
          </p>
        </div>
      </div>

      <div className="p-6 sm:p-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
        {gameProducts.map((p) => (
          <GameCard key={p.id} p={p} />
        ))}
      </div>
    </div>
  </div>
);

/* ---------------- E-BOOK ---------------- */
const EbookSection = () => (
  <div data-testid="ebook-section">
    <div className="rounded-[28px] glass-purple p-8 sm:p-12 relative overflow-hidden">
      <div className="absolute -top-24 -left-16 w-[380px] h-[380px] rounded-full bg-[#3a0ca3]/35 blur-3xl" />
      <div className="relative grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7 order-2 lg:order-1">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-[11px] tracking-[0.18em] uppercase text-[#cdb6ff]">
            <BookOpen size={14} /> Knowledge Library
          </div>
          <h3 className="font-display font-black text-4xl sm:text-5xl mt-5 leading-[1.02]">
            Koleksi <span className="gradient-purple">E-Book Premium</span>
          </h3>
          <p className="mt-4 text-white/70 text-base sm:text-lg leading-relaxed max-w-xl">
            Koleksi e-book premium untuk pengembangan diri, bisnis, mindset, dan
            skill upgrade. Dapatkan inspirasi dari penulis terbaik dunia.
          </p>

          <div className="mt-7 space-y-3">
            {ebookProducts.map((b) => (
              <div
                key={b.id}
                data-testid={`ebook-row-${b.id}`}
                className="product-card p-4 sm:p-5 flex items-center gap-4"
              >
                <div className="w-14 h-14 rounded-2xl flex items-center justify-center bg-gradient-to-br from-[#7B2DFF] to-[#3a0ca3] glow-purple shrink-0">
                  <BookOpen size={22} className="text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2">
                    <h4 className="font-display font-bold text-base sm:text-lg leading-tight">
                      {b.name}
                    </h4>
                    {b.request && (
                      <span className="text-[10px] uppercase tracking-[0.14em] px-2 py-0.5 rounded-full bg-[#7B2DFF]/20 text-[#cdb6ff] border border-[#7B2DFF]/30 whitespace-nowrap">
                        Custom
                      </span>
                    )}
                  </div>
                  {b.author && (
                    <p className="text-white/55 text-xs sm:text-sm mt-0.5">
                      by {b.author}
                    </p>
                  )}
                  <p className="text-white/65 text-xs sm:text-sm mt-1.5 line-clamp-2">
                    {b.desc}
                  </p>
                  <div className="font-display font-extrabold text-lg mt-2 gradient-purple">
                    {b.price}
                  </div>
                </div>
                <WhatsAppButton
                  testId={`ebook-buy-${b.id}`}
                  href={buildWA(
                    b.request ? `Request E-Book (${b.name})` : `E-Book ${b.name}`,
                    b.price
                  )}
                  className="!py-2.5 !px-4 text-xs shrink-0"
                >
                  {b.request ? "Request" : "Beli"}
                </WhatsAppButton>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 order-1 lg:order-2 flex justify-center">
          <div className="relative">
            <div className="absolute -inset-10 bg-[#7B2DFF]/30 blur-3xl rounded-full" />
            <div className="relative w-[220px] sm:w-[260px] aspect-[2/3] rounded-2xl overflow-hidden glow-purple float-soft">
              <img
                src={ebookProducts[0].cover}
                alt="Atomic Habits cover"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

/* ---------------- WRAPPER ---------------- */
const Catalog = () => {
  return (
    <section
      id="katalog"
      data-testid="catalog-section"
      className="relative py-24 sm:py-28"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeader
          kicker="Katalog Produk"
          title={
            <>
              Pilihan Lengkap untuk{" "}
              <span className="gradient-purple">Setiap Kebutuhan Digital</span>
            </>
          }
          subtitle="Tiga kategori unggulan: Capcut Premium, Game Repack berkualitas, dan E-Book inspiratif. Semua harga sudah pasti, semua transaksi aman via WhatsApp."
        />

        <div className="mt-14 space-y-12">
          <CapcutSection />
          <GameSection />
          <EbookSection />
        </div>
      </div>
    </section>
  );
};

export default Catalog;
